// Centralized media assets for WearSpray
export const ASSETS = {
  heroWrist:
    "https://static.prod-images.emergentagent.com/jobs/ec62b2d0-2ad9-4890-99e3-2e35ee4d6bac/images/55737e390d69b9749780b2d14fd15c9429ce8bda7c5901060cb86f8db97399fe.png",
  productBand:
    "https://static.prod-images.emergentagent.com/jobs/ec62b2d0-2ad9-4890-99e3-2e35ee4d6bac/images/becfd0321012be5e3546f3985cd8d25b47f69354e57c1b8525721ea761d19ab3.png",
  realWristHero:
    "https://customer-assets-eiarnc6j.emergentagent.net/job_wearspray-refresh/artifacts/xm4rskev_new%20silicone%201.jpg",
  actionPress:
    "https://static.prod-images.emergentagent.com/jobs/ec62b2d0-2ad9-4890-99e3-2e35ee4d6bac/images/dc6e040358c1bd3d1bc6a655c085f39b9ab0843b5ba913c839dd81f5ebb2553d.png",
  actionDispense:
    "https://static.prod-images.emergentagent.com/jobs/ec62b2d0-2ad9-4890-99e3-2e35ee4d6bac/images/fb4c4a3a58467426ba4e8a8295f36239bf31867c65dec4c87b3b0d7a8972fd38.png",
  techExploded:
    "https://static.prod-images.emergentagent.com/jobs/ec62b2d0-2ad9-4890-99e3-2e35ee4d6bac/images/2c418771abd0a30e0e8ef263869ed1f952619a665a2954c1074cf68d48c2a134.png",
  smartwatch:
    "https://static.prod-images.emergentagent.com/jobs/ec62b2d0-2ad9-4890-99e3-2e35ee4d6bac/images/c9f3ba0fa65be42fdc89a7636d58f825055ec9e9839dc1ceb975174ffcb02431.png",
  valveCrossSection:
    "https://customer-assets-eiarnc6j.emergentagent.net/job_wearspray-refresh/artifacts/ywrawxkf_new%20cad%20valve%20crosssection.jpg",
  reservoirRefill:
    "https://customer-assets-eiarnc6j.emergentagent.net/job_wearspray-refresh/artifacts/stq6g31v_new%20face.jpg",
  valveMacro:
    "https://static.prod-images.emergentagent.com/jobs/ec62b2d0-2ad9-4890-99e3-2e35ee4d6bac/images/e5722ea53506f54b2364e406d509b8333739b1227c07b878fcf31baadc7d4701.png",
  realReservoirVelcro:
    "https://static.prod-images.emergentagent.com/jobs/ec62b2d0-2ad9-4890-99e3-2e35ee4d6bac/images/c1628632738ad4ecc1dc71ff13408a5ccd9975acd97df9b5373693f2da0b722f.png",
  realValveMacro:
    "/prototype/valve-clean.jpg",
  smartwatchReal:
    "https://customer-assets-eiarnc6j.emergentagent.net/job_wearspray-refresh/artifacts/7kfka8zz_neon%20line.jpg",
  smartwatchTeal:
    "https://static.prod-images.emergentagent.com/jobs/ec62b2d0-2ad9-4890-99e3-2e35ee4d6bac/images/37ac1c28e81e719980e0c9a5813525d4b9e2d22faed7dd67847d93f43e944370.png",
  senseGlow:
    "https://customer-assets-eiarnc6j.emergentagent.net/job_wearspray-refresh/artifacts/ndjtsqd7_magenta%20drive.webp",
  fingerPressReservoir:
    "https://customer-assets-eiarnc6j.emergentagent.net/job_wearspray-refresh/artifacts/oshh42uf_finger%20push%20magenta4.jpg",
  lotionInHand:
    "https://customer-assets-eiarnc6j.emergentagent.net/job_wearspray-refresh/artifacts/fgemey5c_hand%20lotion%202.webp",
  liquidSplash:
    "https://images.unsplash.com/photo-1589295926521-49b366c49767?crop=entropy&cs=srgb&fm=jpg&q=85",
  outdoor:
    "https://customer-assets.emergentagent.com/job_wearspray-refresh/artifacts/uajcttu7_ChatGPT%20Image%20Jun%2027%2C%202026%20at%2006_38_52%20PM.png",
  translucentGlow:
    "https://customer-assets-eiarnc6j.emergentagent.net/job_wearspray-refresh/artifacts/fd2b2a8360ae0aaa_better%20magenta2.jpg",
};

export const SAFE_BAND_URL = "https://safebandpro.com";

export const REVEAL_STEPS = [
  { src: "/prototype/reveal-step-1.jpg", step: "01", title: "Closed", body: "A refined round timepiece on the wrist: time, date and status at a glance." },
  { src: "/prototype/reveal-step-2.jpg", step: "02", title: "Flip Open", body: "A single motion hinges the face open, like a locket." },
  { src: "/prototype/reveal-step-3.jpg", step: "03", title: "Reveal & Dispense", body: "The round dispensing reservoir is revealed, ready on demand." },
];

export const VISION = {
  luxuryWatch: "https://customer-assets-eiarnc6j.emergentagent.net/job_wearspray-refresh/artifacts/8ifdfs7t_new%20red%20jeweles.jpg",
  conceptWatchClosed:
    "https://static.prod-images.emergentagent.com/jobs/ec62b2d0-2ad9-4890-99e3-2e35ee4d6bac/images/76921f714b78ef3d7f63b2aef3e5d230a4639535939ff9776298eee29e04f8eb.png",
  conceptWatchOpen:
    "https://static.prod-images.emergentagent.com/jobs/ec62b2d0-2ad9-4890-99e3-2e35ee4d6bac/images/4e4803cd0442d0bfb67476b346c7019b73c8dc7b408dad929b97368338178a4c.png",
  luxuryCuff:
    "https://customer-assets.emergentagent.com/job_wearspray-refresh/artifacts/eri77m3z_Magenta%20Bangle.jpg",
  lifestylePink:
    "https://customer-assets.emergentagent.com/job_wearspray-refresh/artifacts/2ll2e9aj_magenta%20vibe.jpg",
  flipReveal:
    "https://static.prod-images.emergentagent.com/jobs/ec62b2d0-2ad9-4890-99e3-2e35ee4d6bac/images/d22245ddad03068996e1152e6639525a327f587cbeca81c3a03250dbce94c12b.png",
};

export const VISION_FEATURES = [
  { icon: "Droplet", title: "Reservoir", body: "An active dispensing chamber that stores and delivers your liquid formulation cleanly and precisely." },
  { icon: "Wind", title: "Dual-Function Micro Valve", body: "A dispensing and breathing element that controls release while letting the reservoir breathe for smooth, precise output." },
  { icon: "Fingerprint", title: "Programmable Action Triggers", body: "Tactile control points assignable to instant actions: text, email, memo, time, call, or trigger a dispense." },
  { icon: "Radio", title: "Phone + Voice Connection", body: "Connected intelligence and control, paired to your phone and voice assistant." },
];

export const SMART_ACTIONS = [
  { icon: "AudioLines", title: "Voice Assistant", body: "Speak, and it's handled." },
  { icon: "MessageSquare", title: "Send Text", body: "Message without reaching for your phone." },
  { icon: "Mail", title: "Send Email", body: "Compose and send on the go." },
  { icon: "NotebookPen", title: "Take Memo", body: "Catch a thought before it's gone." },
  { icon: "Clock", title: "Check Time", body: "Time and date at a glance." },
  { icon: "PhoneCall", title: "Call Contact", body: "Connect with one press." },
  { icon: "Droplets", title: "Dispense / Apply", body: "Precision dispense on demand." },
];

export const EXPLODE_VIDEO = "/prototype/blue-band-explode.mp4";
export const CAD_OVERLAY = "/prototype/cad-overlay.png";

export const PROTOTYPE_GALLERY = [
  { src: "https://static.prod-images.emergentagent.com/jobs/ec62b2d0-2ad9-4890-99e3-2e35ee4d6bac/images/c1628632738ad4ecc1dc71ff13408a5ccd9975acd97df9b5373693f2da0b722f.png", label: "Open reservoir + cap" },
  { src: "https://static.prod-images.emergentagent.com/jobs/ec62b2d0-2ad9-4890-99e3-2e35ee4d6bac/images/76115b514aa5961ffd89c3a2e8bce062428180d756ecd41f216d3192840c582e.png", label: "Reservoir in housing" },
  { src: "/prototype/valve-clean.jpg", label: "Breathing valve" },
  { src: "https://customer-assets-eiarnc6j.emergentagent.net/job_wearspray-refresh/artifacts/9k4urnxp_new%20reservoir.jpg", label: "Valve assembly" },
  { src: "/prototype/blue-reservoir-rot.png", label: "Reservoir & valve" },
];

export const HERO_VIDEO = "/prototype/hero-360.mp4";

export const EVOLUTION = [
  {
    step: "01",
    title: "Awareness",
    body: "Wearables helped us understand our health and stay aware of what matters: biometrics, alerts, reminders and activity.",
  },
  {
    step: "02",
    title: "Add a Dispensing Reservoir",
    body: "A refillable circular reservoir integrates cleanly into the wearable form factor, transforming the device from awareness to action.",
  },
  {
    step: "03",
    title: "Awareness + Action",
    body: "The next step in wearables: real-time protection when and where you need it. From something you check, to something that helps you act.",
  },
];

export const PLATFORM_COMPONENTS = [
  { icon: "Droplet", title: "Micro Valve", body: "Precision dispensing and breathing valve positioned at 12 o'clock for smooth, controlled output." },
  { icon: "Smartphone", title: "Smart Display", body: "Integrated digital interface for time, status, and connected controls." },
  { icon: "FlaskConical", title: "Refillable Reservoir", body: "Active dispensing chamber, refillable with your preferred liquid, lotion or gel." },
  { icon: "Hexagon", title: "LDPE Core", body: "Durable, collapsible low-density polyethylene core that maintains shape and enables smooth flow." },
  { icon: "Watch", title: "Silicone Band", body: "Soft, durable, skin-friendly band built for all-day comfort." },
  { icon: "ShieldCheck", title: "Protective Housing", body: "Compact housing engineered to frame and safeguard the reservoir and electronics." },
];

export const PLATFORM_SPECS = [
  { icon: "Circle", label: "Diameter", value: "42 mm" },
  { icon: "Ruler", label: "Thickness", value: "15 mm" },
  { icon: "Weight", label: "Weight", value: "46 g" },
  { icon: "Zap", label: "Power", value: "3V CR2032" },
  { icon: "Droplets", label: "Water Resistance", value: "Splash resistant" },
  { icon: "Layers", label: "Materials", value: "ABS · TPU · LDPE · Silicone" },
];

export const HOW_STEPS = [
  {
    img: "https://static.prod-images.emergentagent.com/jobs/ec62b2d0-2ad9-4890-99e3-2e35ee4d6bac/images/0bb7f458ed93f7ef8f935430806b9a007fc2f2e7db4a25e4c0e85a99cc3bd7d8.png",
    title: "Reservoir & Valve",
    body: "At the core sits the refillable reservoir housing our patented breathing valve, the heart of the system.",
  },
  {
    img: "https://customer-assets-eiarnc6j.emergentagent.net/job_wearspray-refresh/artifacts/2mj8ubl4_dispence%20new.jpg",
    title: "Pour Your Solution",
    body: "Fill the reservoir with the personal care product you want within reach, from sunscreen and moisturizer to repellent or sanitizer. Seal the cap, secure WearSpray to your wrist, and you are ready to go.",
  },
  {
    img: "https://customer-assets-eiarnc6j.emergentagent.net/job_wearspray-refresh/artifacts/oshh42uf_finger%20push%20magenta4.jpg",
    title: "Press the Reservoir Face",
    body: "Worn on the wrist, a simple press of the reservoir face releases a precise, controlled stream. No bottles, no pockets, no fumbling.",
  },
  {
    img: "https://customer-assets-eiarnc6j.emergentagent.net/job_wearspray-refresh/artifacts/qwf76isr_palm%20catch%20woman%20hand.jpg",
    title: "Ready When You Are",
    body: "Your personal care product is delivered directly into your palm, giving you immediate access when it is time to act.",
  },
];

export const GLOBAL_HEALTH = {
  stats: [
    { value: "30-40%", label: "of malaria transmission now happens in daylight hours, the window bed nets can't cover." },
    { value: "Night only", label: "Bed nets do vital work indoors at night, but leave people exposed once the day begins." },
    { value: "100+", label: "countries live with active malaria transmission and urgent distribution needs." },
  ],
  protects: [
    { icon: "Users", title: "Women", body: "Carrying the daily load of work, water and care, often outdoors, often unprotected during peak exposure." },
    { icon: "Baby", title: "Children", body: "The most vulnerable to malaria. Daytime protection they can wear, understand and rely on." },
    { icon: "Wheat", title: "Field & Farm Workers", body: "Long hours in high-exposure environments where protection has to travel with the person, not sit at home." },
    { icon: "HeartHandshake", title: "Whole Communities", body: "A shared, refillable layer of protection that a village, school or clinic can sustain together." },
  ],
  refill: [
    { step: "01", title: "Fill at a local hub", body: "Top up repellent at a school, clinic, community center or church. Protection sourced close to home." },
    { step: "02", title: "Wear it through the day", body: "The band stays on the wrist, ready the moment exposure begins. No bottles, no searching." },
    { step: "03", title: "Apply on demand", body: "A single press delivers a precise dose exactly when and where it's needed." },
    { step: "04", title: "Refill & reuse", body: "One durable band, used again and again: an eco-friendly model built for real communities." },
  ],
  distribution: [
    { icon: "Landmark", title: "NGO & Government Programs", body: "Field distribution that complements existing malaria-prevention strategies at scale." },
    { icon: "School", title: "Schools & Community Hubs", body: "Refill stations at trusted local gathering points keep protection accessible and consistent." },
    { icon: "Tent", title: "Humanitarian & Aid Settings", body: "Lightweight, refillable protection for refugee and emergency-response environments." },
  ],
  photos: {
    heroSketch: "https://customer-assets.emergentagent.com/job_wearspray-refresh/artifacts/7eobk5ev_child%20wearing%20band%20drawing.jpg",
    cycle: "https://customer-assets.emergentagent.com/job_wearspray-refresh/artifacts/embapjh5_cycle%20drawing.jpg",
    children: "https://customer-assets.emergentagent.com/job_wearspray-refresh/artifacts/8c2wdoyh_children%20wearing%20bands.png",
  },
};

export const LOGO = "/wearspray-logo-2026.png";
